import Address from './address';

export default function CardPaymentMethod(data){
    let paymentMethod = data || {};
    this.id = paymentMethod.id;
    this.type = "Card";
    this.brand = paymentMethod.brand;
    this.number = paymentMethod.number;
    this.expMonth = paymentMethod.expMonth;
    this.expYear = paymentMethod.expYear;
    this.cvc = paymentMethod.cvc;
    this.name = paymentMethod.name;
    this.phone = paymentMethod.phone;
    this.isDefault = paymentMethod.isDefault;
    this.address = paymentMethod.address !== undefined ? new Address(paymentMethod.address) : undefined;
}